import { render, staticRenderFns } from "./SideLeft.vue?vue&type=template&id=35c074ca&scoped=true&"
import script from "./SideLeft.vue?vue&type=script&lang=js&"
export * from "./SideLeft.vue?vue&type=script&lang=js&"
import style0 from "./SideLeft.vue?vue&type=style&index=0&id=35c074ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c074ca",
  null
  
)

export default component.exports